var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hkl-next-reviewer" },
    [
      _c(
        "HKLModal",
        _vm._g(
          _vm._b(
            {
              ref: "modal",
              staticClass: "hkl-next-reviewer__modal",
              attrs: {
                okBtnAction: _vm.okBtnAction,
                beforeOkClick: _vm.validate,
              },
            },
            "HKLModal",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("template", { slot: "title" }, [_vm._t("title")], 2),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "hkl-next-reviewer__selector" },
            [
              _c(
                "HKLForm",
                { ref: "formRef" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "hkl-next-reviewer__title",
                      class: { "required-flag": _vm.required },
                    },
                    [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]
                  ),
                  _vm._v(" "),
                  _c("HKLSelect", {
                    directives: [
                      {
                        name: "fusioninputcheck",
                        rawName: "v-fusioninputcheck",
                        value: {
                          type: "string",
                          required: true,
                          showTip: false,
                        },
                        expression:
                          "{\n            type: 'string',\n            required: true,\n            showTip: false,\n          }",
                      },
                    ],
                    attrs: { showSearch: true, options: _vm.options },
                    model: {
                      value: _vm.newReviewer,
                      callback: function ($$v) {
                        _vm.newReviewer = $$v
                      },
                      expression: "newReviewer",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "hkl-next-reviewer__add-text" },
            [_vm._t("add-text")],
            2
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }